class QuantityWrapper extends HTMLElement {
  constructor() {
    super();

    const quantity = this.querySelector("[data-quantity]");
    const form = this.closest("[data-form]");
    const incrementButton = this.querySelector("[data-increment]");
    const decrementButton = this.querySelector("[data-decrement]");
    const value = parseInt(quantity.value);
    const changeEvent = new Event("change", { bubbles: true });
    const removeButton = this.querySelector("[data-remove]");

    const increment = () => {
      quantity.value = value + 1;
      form.dispatchEvent(changeEvent);
    };

    const decrement = () => {
      if (value > 0) {
        quantity.value = value - 1;
        form.dispatchEvent(changeEvent);
      }
    };

    incrementButton.addEventListener("click", increment);
    decrementButton.addEventListener("click", decrement);

    if (removeButton) {
      removeButton.addEventListener("click", () => {
        quantity.value = 0;
        form.dispatchEvent(changeEvent);
      });
    }
  }
}

customElements.define("quantity-wrapper", QuantityWrapper);
